<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div *ngIf="archive" class="item-panel">
				<div class="heading">Record new adjustment</div>
				<div class="content">
					<div class="row">
						<div class="col-lg-6">
							<p>Adjustments:</p>
							<table class="table adjustments">
								<ng-container *ngFor="let adjdef of rotor.adjdef; let i = index">
									<!-- Display heading for every "display group" -->
									<tr *ngIf="i === 0 || rotor.adjdef[i].displaygroup !== rotor.adjdef[i-1].displaygroup">
										<th></th>
										<th *ngFor="let blade of FilterBlades(rotor.adjdef[i].displaygroup)">{{blade.name}}</th>
									</tr>
									<tr>
										<th>{{adjdef.name}}</th>
										<td *ngFor="let blade of FilterBlades(rotor.adjdef[i].displaygroup); let j = index">
											<input type="number" step="any" class="form-control" [(ngModel)]="archive.adjustments[i][j]">
										</td>
									</tr>
								</ng-container>
							</table>
						</div>
						<div class="col-lg-6">
							<p>Adjustment generated from operation: {{archive.operation_start | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}</p>
							<div class="form-group">
								<label>User note:</label>
								<div>
									<textarea [(ngModel)]="userNote" style="width: 100%;height: 150px;"></textarea>
								</div>
							</div>
							<app-action-button [action]="UploadAdjustment" [context]="this" processing="Saving..." complete="Adjustment recorded">Record
								adjustment</app-action-button>
							<button (click)="CancelAdjustment()" class="btn btn-danger ml-2">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-4">
			<div *ngIf="regimeCounts" class="row">
				<div class="col-12">
					<div class="item-panel">
						<div class="heading">Regimes</div>
						<div class="content">
							<table class="table regimes">
								<tr>
									<th># Acq</th>
									<th>Regime</th>
									<th>Evaluate</th>
								</tr>
								<tr *ngFor="let regime of regimeCounts">
									<td>{{regime.count}}</td>
									<td>{{regime.name}}</td>
									<td class="center">
										<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
									</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="rotor.balancedata && rotor.balancedata.numblades >= 4" class="row">
				<div class="col-sm-4">
					Shaft Order
				</div>
				<div class="col-sm-8">
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input [(ngModel)]="shaftOrder" name="shaftorder" class="form-check-input" type="radio" [value]="1" (ngModelChange)="loadRegimes()">
							1/rev
						</label>
					</div>
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input [(ngModel)]="shaftOrder" name="shaftorder" class="form-check-input" type="radio" [value]="2" (ngModelChange)="loadRegimes()">
							2/rev
						</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-4">
					Sensor
				</div>
				<div class="col-sm-8">
					<div *ngFor="let vshaft of vshafts" class="form-check">
						<label class="form-check-label">
							<input [(ngModel)]="selectedVShaft" name="vshaft" class="form-check-input" type="radio" [value]="vshaft" (ngModelChange)="loadRegimes()">
							{{vshaft.name}} ({{vshaft.shftid}})
						</label>
					</div>
				</div>
			</div>
		</div><!-- End left column -->
		<div class="col-lg-8">
			<div class="item-panel">
				<div class="heading">Averages (polar)</div>
				<div class="content">
					<div class="comp-plot">
						<app-dvs-chart #polarChart [options]="polarOptions" [light]="true" [height]="'600px'" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Averages (timeline)</div>
				<div class="content">
					<app-dvs-chart #timelineChart [options]="timelineOptions" [light]="true" [height]="'200px'" [timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
					<div *ngIf="timelineOptions && adjustments && adjustments.length" class="legend">
						<span class="legend-item">
							<span class="swatch" style="background-color: #f3f700"></span> Adjustment (see below)
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Adjustment History</div>
				<div class="content">
					<div *ngIf="adjustments && !adjustments.length">
						No adjustments have been recorded for this rotor
					</div>
					<div *ngIf="adjustments && adjustments.length" class="adjustment-list">
						<p>Rotor blades: {{blades}}</p>
						<table>
							<tr>
								<th>Operation</th>
								<th>Entered by</th>
								<th *ngFor="let adjdef of rotor.adjdef">{{adjdef.name}}</th>
								<th>User note</th>
								<th *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									Delete</th>
							</tr>
							<tr *ngFor="let adjustment of adjustments">
								<td>{{adjustment.operation_start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
								<td>{{adjustment.author_email}}</td>
								<td *ngFor="let row of adjustment.adjustments.split('|')">{{row | commalist}}</td>
								<td class="truncate" [title]="adjustment.user_note"><span>{{adjustment.user_note}}</span></td>
								<td *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									<app-action-button [action]="DeleteAdjustment" [args]="[adjustment.adjustment_history_id]" [context]="this" btnClass="btn-danger btn-sm" confirm="Are you sure?"
										processing="...">x
									</app-action-button>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>